const footer = {
  navigation: {
    mainPage: 'الصفحة الرئيسية',
    interactiveMap: 'الخارطة التفاعلية',
    reports: 'التقارير',
  },
  pages: {
    termsAndConditions: 'الشروط و الأحكام',
    privacyPolicy: 'سياسة الخصوصية',
  },
  categories: {
    businessServices: 'خدمات الأعمال',
    supportAndHelp: 'الدعم والمساعدة',
    followUs: 'تابعنا على',
  },
  initiativeBy: 'مبادرة من',
}

export default footer;
